import { RaceProgressRegistrationData } from "./interfaces/race_progress_registration_data_raw.interface";
import { RaceProgressRegistrationRaw } from "./interfaces/race_progress_registration_raw.interface";
import { RaceProgressLap } from "./race_progress_lap";

export class RaceProgressRegistration {
    DNF!: number;
    DNFreason!: string;
    atStartTime!: number;
    bestLap!: number;
    bestTime!: number;
    className!: string;
    classSortPosition!: number;
    delMarks!: [];
    deltaLeader!: number;
    finGPStime!: number;
    finTime!: number;
    racePosition!: string;
    isCrewClass!: boolean;
    laps!: RaceProgressLap[];
    lapsDSQ!: number;
    lapsRes!: number;
    penalty!: number;
    penaltyComment!: string;
    raceTime!: number;
    registration!: RaceProgressRegistrationData;
    startGPStime!: number;
    startTime!: number;

    // показывать или нет доп инфу в таблице
    tableShowDetails = false;

    constructor(obj: RaceProgressRegistrationRaw) {
        this.update(obj);
    }

    update(obj: RaceProgressRegistrationRaw) {
        this.DNF = obj.DNF;
        this.DNFreason = obj.DNFreason;
        this.atStartTime = obj.atStartTime;
        this.bestLap = obj.bestLap;
        this.bestTime = obj.bestTime;
        this.className = obj.className;
        // TODO не использовать в html 28 строке файл
        this.classSortPosition = obj.classSortPosition;
        this.delMarks = obj.delMarks;
        this.deltaLeader = obj.deltaLeader;
        this.finGPStime = obj.finGPStime;
        this.finTime = obj.finTime;
        this.isCrewClass = obj.isCrewClass;
        this.laps = obj.laps?.map((item) => new RaceProgressLap(item));
        this.lapsDSQ = obj.lapsDSQ;
        this.lapsRes = obj.lapsRes;
        this.penalty = obj.penalty;
        this.penaltyComment = obj.penaltyComment;
        this.raceTime = obj.raceTime;
        this.registration = new RaceProgressRegistrationData(obj.registration);
        this.startGPStime = obj.startGPStime;
        this.startTime = obj.startTime;
        this.racePosition = obj.racePosition;
    }
}